import { downloadCaseDatePdfAPI } from 'actions/Master/masterAction';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CaseDatePDFConfirmationModal = ({ show, onConfirm, onCancel, data }) => {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>
      <Modal.Body>Do you want to get the details of the cases?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CaseDatePDFConfirmationModal;
